module.exports = __webpack_public_path__ + "media/flags/ly-b02c7467.svg";